import React from 'react';
export function App() {
  return <div className="min-h-screen bg-midnight flex flex-col items-center justify-center px-6 font-outfit" data-id="element-0">
      {/* Logo */}
      <div className="flex items-end gap-1.5 mb-10" data-id="element-1">
        <div className="flex items-end gap-[2px] h-[22px]" data-id="element-2">
          <div className="w-1.5 h-[10px] bg-signal" data-id="element-3"></div>
          <div className="w-1.5 h-[15px] bg-signal" data-id="element-4"></div>
          <div className="w-1.5 h-[22px] bg-signal" data-id="element-5"></div>
        </div>
        <div className="text-[22px] tracking-tight leading-none" data-id="element-6">
          <span className="font-extrabold text-ivory" data-id="element-7">Highrise</span>
          <span className="font-normal text-ivory/50 ml-1" data-id="element-8">Lab</span>
        </div>
      </div>

      {/* Heading */}
      <h1 className="text-[36px] md:text-[48px] font-extrabold text-ivory tracking-tight text-center leading-tight mb-4" data-id="element-9">
        Coming Soon
      </h1>
      <p className="text-ivory/40 text-[16px] text-center max-w-md" data-id="element-10">
        We're building something great. Stay tuned.
      </p>
    </div>;
}